import { Badge, IconButton, Typography } from '@mui/material';
import { LightTooltip } from 'components/shared/CustomTooltip/CustomTooltip';
import zeplinColor from 'theme/Color';
import { FilterBadgeProps } from '../types';

export const FilterBadge = ({ activeFilterCount, onClick }: FilterBadgeProps) => {
  return (
    <Badge
      badgeContent={activeFilterCount}
      color='primary'
      sx={{ '.MuiBadge-badge': { top: '0.7rem', right: '0.2rem' } }}
    >
      <LightTooltip
        title={
          <Typography variant='body3' color={zeplinColor.Neutral1}>
            Filter
          </Typography>
        }
        placement='bottom-start'
        style={{ backgroundColor: zeplinColor.BasicBlack, borderRadius: '8px' }}
      >
        <IconButton
          sx={{
            width: { xs: '30px', xl: '48px' },
            height: { xs: '30px', xl: '48px' },
            border: `1px solid ${zeplinColor.Neutral6}`,
          }}
          onClick={onClick}
        >
          <img src={'/assets/filter.svg'} alt='filter icon' />
        </IconButton>
      </LightTooltip>
    </Badge>
  );
};
